import React from 'react'
import DisableApplications from './DisableApplications'
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const RegularDisableApplications = () => {

    const editApplicationPermission = checkPermission(
        permissionsConfig.editDisabledApplications.role,
        permissionsConfig.editDisabledApplications.action,
        permissionsConfig.editDisabledApplications.type
    );
        
    const deleteApplicationPermission = checkPermission(
        permissionsConfig.deleteDisabledApplications.role,
        permissionsConfig.deleteDisabledApplications.action,
        permissionsConfig.deleteDisabledApplications.type
    );

    return (
        <DisableApplications application_type="0" pageFrom="disable-applications" editApplicationPermission={editApplicationPermission} deleteApplicationPermission={deleteApplicationPermission}></DisableApplications>
    )
}

export default RegularDisableApplications